import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../Context/Authcontext';
import Loading from '../components/Loading/Loading';

export default function RoleProtector({ children, requiredRole }) {
    const { userRole } = useContext(AuthContext);

    if (userRole === null || userRole === undefined) {
        return <Loading />;
    }
    if (userRole !== requiredRole) {

        if (userRole === "admin") {
            return <Navigate to="/admin" replace />;

        } else if (userRole === "analyst") {
            return <Navigate to="/analyst" replace />;

        } else if (userRole === "viewer") {
            return <Navigate to="/" replace />;

        } else {
            return <Navigate to="/Auth/Login" replace />;
        }
    }


    return children;
}